import axios from '../../config/axiosConfig';
import { CREATE_SCHEDULE, GET_SCHEDULES, SCHEDULE_REQUEST, DELETE_SCHEDULE, UPDATE_SCHEDULE, SCHEDULE_REQUEST_FAILURE } from '../types';
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getSchedules = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SCHEDULE_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            return axios.get('/schedule/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_SCHEDULES, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createSchedule = (schedule) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: SCHEDULE_REQUEST });

            return axios.post('/schedule/add', schedule,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_SCHEDULE, payload: response.data });
                    dispatch(addMasterInOption('schedules', response.data));
                } else {
                    dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: 'Schedule create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateSchedule = (id, data) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SCHEDULE_REQUEST });
            const { auth } = getState();
            return axios.put('/schedule/update', { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_SCHEDULE, payload: { id, data: response.data } });
                    dispatch(updateMasterInOption('schedules', id, response.data));
                } else {
                    dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: 'Schedule update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteSchedule = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SCHEDULE_REQUEST });
            return axios.delete(`/schedule/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_SCHEDULE, id: id });
                    dispatch(updateMasterInOption('schedules', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SCHEDULE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};